<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-encrypted-document`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M39 3a2 2 0 012 2l-.001 11.999h-4L37 7H9v36h10v4H7a2 2 0 01-2-2V5a2 2 0 012-2h32zm-4 19a7 7 0 017 7h2a2 2 0 012 2v12a2 2 0 01-2 2H26a2 2 0 01-2-2V31a2 2 0 012-2h2a7 7 0 017-7zm7 11H28v8h14v-8zm-7-7a3 3 0 00-3 3h6a3 3 0 00-3-3zm-11-5a1 1 0 011 1v2a1 1 0 01-1 1H14a1 1 0 01-1-1v-2a1 1 0 011-1h10zm8-8a1 1 0 011 1v2a1 1 0 01-1 1H14a1 1 0 01-1-1v-2a1 1 0 011-1h18z"/></svg>
</template>
<script>

export default {
  name: 'IconEncryptedDocument',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
